const debug = require('debug')('cartsee:events');

export const PATH_CHANGE_EVENT = 'cartsee/page/change';

export const initEvents = () => {
  let currentPath = window.location.pathname;
  // 创建 MutationObserver 实例
  const observer = new MutationObserver(function (mutations) {
    // 获取新的页面路径
    const newPath = window.location.pathname;
    // 只有当路径发生变化时才执行逻辑
    if (newPath !== currentPath) {
      debug('页面路径变化: 从 %s 变为 %s', currentPath, newPath);
      // 更新当前路径
      currentPath = newPath;
      // 触发事件
      window.dispatchEvent(new CustomEvent(PATH_CHANGE_EVENT, { detail: { oldPath: currentPath, newPath } }));
    }
  });

  // 配置观察选项
  const config = {
    childList: true, // 观察目标子节点的变化
    subtree: true // 观察后代节点
  };

  // 开始观察
  observer.observe(document.body, config);
  // 在组件卸载时停止观察
  window.addEventListener('unload', () => {
    observer.disconnect();
  });
};
